import Block from '../block'

export default class NavScaling extends Block {
	static title = 'nav-scaling'

	static CLOSE_DURATION = 700

	constructor($el) {
		super($el)

		this.$el.find('[data-navigation-toggle="toggle"]').on('click', () => {
			this.toggleNav()
		})

		this.$el.find('[data-navigation-toggle="close"]').on('click', () => {
			this.closeNav()
		})

		$(document).on('keydown', (e) => {
			if (
				e.keyCode === 27 &&
				this.$el.attr('data-navigation-status') === 'active'
			) {
				this.closeNav()
			}
		})

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})
	}

	toggleNav() {
		if (this.$el.attr('data-navigation-status') === 'not-active') {
			clearTimeout(this.blendResetTimer)
			this.$el.removeClass('nav-scaling--closing')
			this.$el.attr('data-navigation-status', 'active')
			this.$el
				.find('[data-navigation-toggle="toggle"]')
				.attr('aria-expanded', 'true')
			// the links sit before the toggle in the DOM, so Tab would otherwise leave the menu
			this.focusFirstLink()
		} else {
			this.closeNav()
		}
	}

	// visibility transitions too, so the first frames still refuse focus
	focusFirstLink(tries = 15) {
		const $link = this.$el.findElement('hamburger-a').first()

		$link.get(0)?.focus()

		if (!$link.is(':focus') && tries > 0) {
			requestAnimationFrame(() => this.focusFirstLink(tries - 1))
		}
	}

	closeNav() {
		const $toggle = this.$el.find('[data-navigation-toggle="toggle"]')

		if (this.$el.find(':focus').length) {
			$toggle.get(0)?.focus()
		}

		this.$el.attr('data-navigation-status', 'not-active')
		this.$el
			.find('[data-navigation-toggle="toggle"]')
			.attr('aria-expanded', 'false')
		this.$el.addClass('nav-scaling--closing')
		clearTimeout(this.blendResetTimer)
		this.blendResetTimer = setTimeout(() => {
			this.$el.removeClass('nav-scaling--closing')
		}, NavScaling.CLOSE_DURATION)
	}
}
